<template>
  <div class="big-legends-main">
    <div class="legends" v-for="(l, li) in legends" :key="li" :style="getLegendStyling(li)" @click="legendClicked(li)">
      {{ l['name'] }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
    }
  },
  props: {
    legends: { type: Array, default: function() { return [] } }, // The legends to show
    // Sample legends
    // {
    //   name: 'Completed',
    //   color: 'green',
    //   textColor: 'black',
    //   show: false
    // }

    // Public Events
    // legendToggle - fired when the legend in toggled, return the toggled legend object
  },
  methods: {
    getLegendStyling: function(index) {
      let data = this.legends[index];

      return {
        borderColor: data['color'] ? data['color'] : 'lightgray',
        backgroundColor: data['show'] ? (data['color'] ? data['color'] : 'lightgray') : 'transparent',
        color: data['show'] ? (data['textColor'] ? data['textColor'] : 'black') : 'black',
        textDecoration: data['show'] ? 'none' : 'line-through'
      }
    },

    legendClicked: function(index) {
      let data = this.legends[index];
      data['show'] = !data['show'];

      this.$emit('legendToggle', this.legends[index]);
    }
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.big-legends-main {
  display: flex;

  > .legends {
    border-style: solid;
    border-width: 2px;
    margin-right: 5px;
    padding: 5px 10px;
    cursor: pointer;
    user-select: none;
  }
}
</style>